//
// Copyright (c) 2023 Emplifi, Inc.
//

export function responseTextHasComments(responseText: string): boolean {
  /*The <comment-start> and <comment-end> tags are added if the comment starts/ends in text,
       otherwise, the following attributes are added to elements:
       data-comment-start-before,
       data-comment-end-after,
       data-comment-start-after,
       data-comment-end-before*/
  return responseText.includes("comment-start");
}
